import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import React from 'react';
import { Dialog } from '@headlessui/react';
import { BackIcon, useIsEmployerApp } from '@restworld/utils-common';
import { Button } from '../../button';
import { XMarkIcon } from '@heroicons/react/24/outline';
import IconButton from '../../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DesktopModal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onClose = _ref.onClose,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'center' : _ref$variant,
      title = _ref.title,
      CloseIcon = _ref.CloseIcon,
      children = _ref.children,
      modalStyles = _ref.modalStyles,
      backIcon = _ref.backIcon,
      showBackButton = _ref.showBackButton,
      onBack = _ref.onBack,
      noPadding = _ref.noPadding,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === void 0 ? false : _ref$hideHeader,
      showCloseIcon = _ref.showCloseIcon,
      footer = _ref.footer,
      footerStyles = _ref.footerStyles,
      primaryActionLabel = _ref.primaryActionLabel,
      onClickPrimaryAction = _ref.onClickPrimaryAction,
      secondaryActionLabel = _ref.secondaryActionLabel,
      onClickSecondaryAction = _ref.onClickSecondaryAction,
      headerStyles = _ref.headerStyles;

  var _useIsEmployerApp = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp.isEmployerApp;

  return /*#__PURE__*/_jsxs(StyledDesktopDialogPanel, {
    variant: variant,
    ref: ref,
    modalstyles: modalStyles,
    $hasOffWhiteBackground: isEmployerApp,
    children: [variant === 'center' && !hideHeader && /*#__PURE__*/_jsx(CenteredModalHeader, {
      title: title,
      onClose: onClose,
      CloseIcon: CloseIcon,
      backIcon: backIcon,
      showBackButton: showBackButton,
      onBack: onBack,
      noPadding: noPadding,
      headerStyles: headerStyles,
      showCloseIcon: showCloseIcon
    }), variant === 'right' && !hideHeader && /*#__PURE__*/_jsx(RightModalHeader, {
      title: title,
      onClose: onClose,
      CloseIcon: CloseIcon,
      showCloseIcon: showCloseIcon,
      headerStyles: headerStyles
    }), /*#__PURE__*/_jsx(DesktopModalBody, {
      variant: variant,
      noPadding: noPadding,
      children: children
    }), (footer || primaryActionLabel || secondaryActionLabel) && /*#__PURE__*/_jsxs(DesktopModalFooter, {
      variant: variant,
      noPadding: noPadding,
      footerStyles: footerStyles,
      children: [footer, (primaryActionLabel || secondaryActionLabel) && /*#__PURE__*/_jsxs(_StyledDiv, {
        children: [primaryActionLabel && /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          title: primaryActionLabel,
          variant: "normal",
          onClick: function onClick() {
            if (onClickPrimaryAction) {
              onClickPrimaryAction();
            }
          }
        }), secondaryActionLabel && /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          title: secondaryActionLabel,
          variant: "secondary-outline",
          onClick: function onClick() {
            if (onClickSecondaryAction) {
              onClickSecondaryAction();
            }
          }
        })]
      })]
    })]
  });
});
export default DesktopModal;

var CenteredModalHeader = function CenteredModalHeader(_ref2) {
  var CloseIcon = _ref2.CloseIcon,
      onClose = _ref2.onClose,
      title = _ref2.title,
      onBack = _ref2.onBack,
      showBackButton = _ref2.showBackButton,
      backIcon = _ref2.backIcon,
      noPadding = _ref2.noPadding,
      headerStyles = _ref2.headerStyles,
      _ref2$showCloseIcon = _ref2.showCloseIcon,
      showCloseIcon = _ref2$showCloseIcon === void 0 ? true : _ref2$showCloseIcon;

  var _useIsEmployerApp2 = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp2.isEmployerApp;

  return /*#__PURE__*/_jsxs(CenteredHeaderStyled, {
    headerStyles: headerStyles,
    $hasOffWhiteBackground: isEmployerApp,
    children: [/*#__PURE__*/_jsxs(StyledButtonContainer, {
      noPadding: noPadding,
      showBackButton: showBackButton,
      children: [showBackButton && /*#__PURE__*/_jsx(_StyledDiv2, {
        onClick: function onClick() {
          return !!onBack && onBack();
        },
        children: backIcon || /*#__PURE__*/_jsx(BackIcon, {})
      }), showCloseIcon && /*#__PURE__*/_jsx(IconButton, {
        ariaLabel: "",
        Icon: CloseIcon || XMarkIcon,
        onClick: function onClick() {
          return onClose();
        }
      })]
    }), !!title && /*#__PURE__*/_jsx(_StyledDiv3, {
      children: typeof title === 'string' ? /*#__PURE__*/_jsx(_StyledH, {
        children: title
      }) : title
    })]
  });
};

var CenteredHeaderStyled = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-modal__CenteredHeaderStyled",
  componentId: "sc-1pz9d5q-0"
})(function (_ref3) {
  var headerStyles = _ref3.headerStyles,
      $hasOffWhiteBackground = _ref3.$hasOffWhiteBackground;
  return [{
    "position": "sticky",
    "top": "0px",
    "zIndex": "10",
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "gap": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingBottom": "0.5rem"
  }, $hasOffWhiteBackground ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  } : {}].concat(_toConsumableArray(headerStyles || []));
});

var RightModalHeader = function RightModalHeader(_ref4) {
  var _ref4$showCloseIcon = _ref4.showCloseIcon,
      showCloseIcon = _ref4$showCloseIcon === void 0 ? true : _ref4$showCloseIcon,
      CloseIcon = _ref4.CloseIcon,
      onClose = _ref4.onClose,
      title = _ref4.title,
      headerStyles = _ref4.headerStyles;

  var _useIsEmployerApp3 = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp3.isEmployerApp;

  return /*#__PURE__*/_jsxs(RightHeaderStyled, {
    headerStyles: headerStyles,
    $hasOffWhiteBackground: isEmployerApp,
    children: [showCloseIcon ? /*#__PURE__*/_jsx(IconButton, {
      ariaLabel: "",
      Icon: CloseIcon || XMarkIcon,
      onClick: function onClick() {
        return onClose();
      }
    }) : null, typeof title === 'string' ? /*#__PURE__*/_jsx(_StyledH2, {
      children: title
    }) : title]
  });
};

var RightHeaderStyled = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-modal__RightHeaderStyled",
  componentId: "sc-1pz9d5q-1"
})(function (_ref5) {
  var headerStyles = _ref5.headerStyles,
      $hasOffWhiteBackground = _ref5.$hasOffWhiteBackground;
  return [{
    "position": "sticky",
    "top": "0px",
    "zIndex": "10",
    "display": "flex",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "gap": "3rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingLeft": "2rem",
    "paddingRight": "2rem",
    "paddingTop": "3rem",
    "paddingBottom": "0.5rem"
  }, $hasOffWhiteBackground ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  } : {}].concat(_toConsumableArray(headerStyles || []));
});

var StyledDesktopDialogPanel = /*#__PURE__*/_styled(Dialog.Panel).withConfig({
  displayName: "desktop-modal__StyledDesktopDialogPanel",
  componentId: "sc-1pz9d5q-2"
})(function (_ref6) {
  var variant = _ref6.variant,
      modalstyles = _ref6.modalstyles,
      hideHeader = _ref6.hideHeader,
      $hasOffWhiteBackground = _ref6.$hasOffWhiteBackground;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "minWidth": "26rem",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "overflow": "hidden",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, variant === 'center' && {
    "minHeight": "fit-content",
    "borderRadius": "0.938rem",
    "paddingBottom": "2rem",
    "@media (min-width: 1024px)": {
      "maxHeight": "calc(100vw - 200px)"
    }
  }, variant === 'right' && {
    "position": "fixed",
    "height": "100%",
    "minHeight": "100%",
    "width": "391px",
    "borderTopLeftRadius": "1.563rem",
    "paddingBottom": "2rem",
    "paddingTop": "0px"
  }, variant === 'right' && hideHeader && {
    "paddingTop": "3rem"
  }, $hasOffWhiteBackground ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  } : {}].concat(_toConsumableArray(modalstyles || []));
});

var DesktopModalBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-modal__DesktopModalBody",
  componentId: "sc-1pz9d5q-3"
})(function (_ref7) {
  var variant = _ref7.variant,
      noPadding = _ref7.noPadding;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "maxWidth": "100%",
    "flex": "1 1 0%",
    "flexGrow": "1",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "overflowY": "auto",
    "paddingBottom": "0.5rem"
  }, variant === 'center' ? {
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  } : {}, variant === 'right' ? {
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  } : {}, noPadding ? {
    "paddingLeft": "0px !important",
    "paddingRight": "0px !important",
    "paddingTop": "0px !important",
    "paddingBottom": "0px !important"
  } : {}];
});

export var StyledButtonContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-modal__StyledButtonContainer",
  componentId: "sc-1pz9d5q-4"
})(["", ";", ";", ";"], {
  "boxSizing": "border-box",
  "display": "flex",
  "width": "100%",
  "flex": "1 1 0%",
  "flexDirection": "row",
  "alignItems": "flex-start",
  "justifyContent": "flex-end",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "1rem"
}, function (_ref8) {
  var showBackButton = _ref8.showBackButton;
  return showBackButton ? {
    "justifyContent": "space-between"
  } : {};
}, function (_ref9) {
  var noPadding = _ref9.noPadding;
  return noPadding ? {
    "paddingLeft": "0px",
    "paddingRight": "0px",
    "paddingTop": "0px"
  } : {};
});

var DesktopModalFooter = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-modal__DesktopModalFooter",
  componentId: "sc-1pz9d5q-5"
})(function (_ref10) {
  var variant = _ref10.variant,
      noPadding = _ref10.noPadding,
      footerStyles = _ref10.footerStyles;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "paddingTop": "1rem",
    "paddingBottom": "1rem"
  }, variant === 'center' ? {
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  } : {}, variant === 'right' ? {
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  } : {}, noPadding ? {
    "paddingLeft": "0px !important",
    "paddingRight": "0px !important",
    "paddingTop": "0px !important",
    "paddingBottom": "0px !important"
  } : {}].concat(_toConsumableArray(footerStyles || []));
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-modal___StyledDiv",
  componentId: "sc-1pz9d5q-6"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-modal___StyledDiv2",
  componentId: "sc-1pz9d5q-7"
})({
  "cursor": "pointer",
  "borderStyle": "none",
  "outline": "2px solid transparent",
  "outlineOffset": "2px"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-modal___StyledDiv3",
  componentId: "sc-1pz9d5q-8"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "justifyContent": "center"
});

var _StyledH = /*#__PURE__*/_styled("h3").withConfig({
  displayName: "desktop-modal___StyledH",
  componentId: "sc-1pz9d5q-9"
})({
  "textAlign": "center",
  "fontSize": "1.25rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(17 24 39 / var(--tw-text-opacity))"
});

var _StyledH2 = /*#__PURE__*/_styled("h3").withConfig({
  displayName: "desktop-modal___StyledH2",
  componentId: "sc-1pz9d5q-10"
})({
  "fontSize": "1.25rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(17 24 39 / var(--tw-text-opacity))"
});